import { z } from 'zod';
import { requiredString } from '../helpers';
export const Call_Add_Context_1_ConfigValidator = z.object({
    content: requiredString('Context message is required'),
    triggerResponseEnabled: z.boolean().optional()
});
//# sourceMappingURL=call-add-context-1.js.map